import { createSlice } from "@reduxjs/toolkit";
const activeSlice = createSlice({
  name: "activepage",
  initialState: "Our Projects",
  reducers: {
    setActiveItem: (state, action) => action.payload,
  },
});

export const { setActiveItem } = activeSlice.actions;

export default activeSlice.reducer;
